import React from 'react';

import CarsSecondSideBar from '../secondSideBars/carsSecondSideBar'

import SideBarInnerWrapper from './../../../shared/sideBarInnerWrapper'
import SideBarInner from './../../../shared/sideBarInner'
import CarsSortPanel from './../cars/carsSortPanel'
import SideBar from './../../sides/sideBar'
import ReportsTitleClosedBar from './../reports/reportsTitleClosedBar'
import ReportsTitleBar from './../reports/reportsTitleBar'
import CarsPaginationSettingsPanel from './../cars/carsPaginationSettingsPanel'
import ReportTypeSelect from './../reports/reportTypeSelect'
import ReportsListWrapper from './../reports/reportsListWrapper'
import CarsPaginationWrapper from './../cars/carsPaginationWrapper'
import SelectAllReportCars from '../reports/selectAllReportCars'

import styles from './reportsBar.module.scss'

const ReportsBar = () => {
  return (
    <div className={styles.sideBarsWrapper}>
      <SideBar
        TitleClosed={<ReportsTitleClosedBar />}
      >
        <div className={styles.reportsBar}>
          <SideBarInner>
            <ReportsTitleBar />
          </SideBarInner>

          <div className={styles.container_reportsBarSection}>
            <SideBarInnerWrapper title="Тип отчета">
              <ReportTypeSelect />
            </SideBarInnerWrapper>
          </div>

          <div className={styles.container_reportsBarSection}>
            <SideBarInnerWrapper title="Транспортные средства">
              <CarsSortPanel />
            </SideBarInnerWrapper>
          </div>

          <SideBarInner>
            <div className={styles.container_carListControls}>
              <div className={styles.container_carListPaginationControls}>
                <CarsPaginationSettingsPanel />
              </div>
              <div className={styles.container_carListSelectControls}>
                <SelectAllReportCars />
              </div>
            </div>

            <div className={styles.container_carsList}>
              <ReportsListWrapper />
              <div className={styles.container_carsPaginationWrapper}>
                <CarsPaginationWrapper />
              </div>
            </div>
          </SideBarInner>
        </div>
      </SideBar>

      <CarsSecondSideBar />
    </div>
  )
}

export default React.memo(ReportsBar)
